import {UIStoreItemView} from './UIStoreItemView'
import {
    areYouSureToBuy,
    areYouSureToBuyFounderDiscount,
    doActionIfCanGiftMembership,
    doActionIfLoggedIn,
} from '../../../shared/scripts/store/StoreUtils'
import {UIStoreAjaxEndPoints} from '../../../shared/scripts/store/UIStoreAjaxEndPoints'
import {StoreItemCategory, StorePresalePackType} from '../../../../shared/entity_datas/StoreEnums'
import {StoreItemController} from '../../../../shared/store/StoreItemController'
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {ColonistCoinProduct} from '../../../../shared/store/ColonistCoinProduct'
import {UICoinProductView} from '../../../shared/scripts/store/UICoinProductView'
import {UIStoreMembershipProductView} from '../../../shared/scripts/store/UIStoreMembershipProductView'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {UIStoreMembershipTabsController} from '../../../shared/scripts/store/UIStoreMembershipTabsController'
import * as Item from '../../../../shared/store/StoreItemList'
import {UIStoreState} from '../../../shared/scripts/store/UIStoreState'
import {UIStoreBodyController} from '../../../shared/scripts/store/UIStoreBodyController'
import {GiftedMembershipItem} from '../../../../shared/store/UserItems'
import {UIGiftedMembershipProductView} from '../../../shared/scripts/store/UIGiftedMembershipProductView'
import {PaymentMethod} from '../../../../shared/store/BaseColonistStoreProduct'
import {ColonistMembershipPerkType} from '@colonist/lobby-types'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {UIStoreGiftOverlayController} from '../../../shared/scripts/store/gift/UIStoreGiftOverlayController'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'

export class UIWStoreBodyController extends UIStoreBodyController {
    protected readonly referralSection: HTMLDivElement
    protected readonly referralItemsDiv: HTMLDivElement
    protected readonly referralInfoDiv: HTMLDivElement
    protected readonly referralSidebarButton: HTMLDivElement
    protected readonly membershipsDiv: HTMLDivElement
    protected readonly expansionsDiv: HTMLDivElement
    protected readonly mapsDiv: HTMLDivElement
    protected readonly colorsDiv: HTMLDivElement
    protected readonly avatarsDiv: HTMLDivElement
    protected readonly coinsDiv: HTMLDivElement
    protected readonly items: UIStoreItemView[] = []
    readonly membershipItems: UIStoreMembershipProductView[] = []
    membershipTabsController: UIStoreMembershipTabsController

    protected readonly storeState: UIStoreState

    constructor(storeState: UIStoreState) {
        super()
        this.referralSection = document.getElementById('referrals') as HTMLDivElement
        this.referralItemsDiv = document.getElementById('store_page_referral_items') as HTMLDivElement
        this.referralInfoDiv = document.getElementById('store_page_referral_info') as HTMLDivElement
        this.referralSidebarButton = document.getElementById('referral_sidebar_button') as HTMLDivElement
        this.membershipsDiv = document.getElementById('store_page_memberships_div') as HTMLDivElement
        this.expansionsDiv = document.getElementById('store_page_expansions_div') as HTMLDivElement
        this.mapsDiv = document.getElementById('store_page_maps_div') as HTMLDivElement
        this.colorsDiv = document.getElementById('store_page_colors_div') as HTMLDivElement
        this.avatarsDiv = document.getElementById('store_page_avatars_div') as HTMLDivElement
        this.coinsDiv = document.getElementById('store_page_coins_div') as HTMLDivElement

        this.storeState = storeState

        this.createGiftOverlay()
        this.createMembershipItems()
        this.updateAllCategoryItems()
        this.createCoinProducts()
    }

    protected createGiftOverlay() {
        const mainContainer = document.getElementById('store_main_container') as HTMLDivElement
        const pageBody = mainContainer.parentElement as HTMLDivElement
        this.giftOverlayController = new UIStoreGiftOverlayController(pageBody, this.storeState)
    }

    protected createMembershipItems() {
        this.membershipsDiv.replaceChildren()
        this.membershipItems.length = 0
        const membershipProducts = ColonistMembershipProduct.getAllMembershipProducts()
        for(const product of membershipProducts) {
            const membership = new UIStoreMembershipProductView(this.membershipsDiv, this.storeState, product, this.giftOverlayController)
            this.membershipItems.push(membership)
        }
        this.membershipTabsController = new UIStoreMembershipTabsController(this.storeState)
    }

    // eslint-disable-next-line class-methods-use-this
    protected updateReferralProgram() {
        return
    }

    protected updateAllCategoryItems() {
        this.items.length = 0
        this.updateCategoryItems(StoreItemCategory.Expansion, this.expansionsDiv)
        this.updateCategoryItems(StoreItemCategory.Map, this.mapsDiv)
        this.updateCategoryItems(StoreItemCategory.Color, this.colorsDiv)
        this.updateCategoryItems(StoreItemCategory.Icon, this.avatarsDiv)
    }

    protected createCoinProducts() {
        const coinProducts = ColonistCoinProduct.getAllCoinProducts()
        for(const product of coinProducts) {
            new UICoinProductView(this.coinsDiv, product)
        }
    }

    updateCategoryItems(category: StoreItemCategory, container: HTMLDivElement) {
        container.replaceChildren()
        const itemDetails = StoreItemController.getItemsInCategory(category)
        for(const itemDetail of itemDetails) {
            const item = new UIStoreItemView(container, itemDetail,
                () => doActionIfCanGiftMembership(() => this.giftOverlayController.show()),
                () => {
                    const eventData: AjaxDataTypes.AnalyticData = {
                        type: AnalyticEventType.StoreClickedPurchaseItem,
                        category: AnalyticEventCategory.Store,
                        floatValue: item.itemDetail.type,
                    }
                    void CA.sendAnalyticEvent(eventData)
                    CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedPurchaseItem, itemDetail.type)

                    const isBlackColor = itemDetail.name.key === new Item.SIColorBlack().name.key

                    if(!isBlackColor) {
                        const forceSubscription = ClientUserState.userState?.forceSubscription ?? true
                        const subscriptionCategory = itemDetail.category == StoreItemCategory.Expansion || itemDetail.category == StoreItemCategory.Map || itemDetail.category == StoreItemCategory.Color
                        if(forceSubscription && subscriptionCategory) {
                            navigateToPage('/store#membership')
                            return
                        }
                    }

                    doActionIfLoggedIn(() => {
                        areYouSureToBuy(itemDetail, () => {
                            CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedApprovePurchaseItem, itemDetail.type)
                            void UIStoreAjaxEndPoints.purchaseItem(itemDetail)
                        })
                    })
                })
            this.items.push(item)
        }
    }

    updateOwnedItems(ownedItems: BaseStoreItem[]) {
        this.updateAllCategoryItems()
        this.updateReferralProgram()
        for(const ownedItem of ownedItems) {
            for(const itemView of this.items) {
                if(itemView.itemDetail.name.key == ownedItem.name.key) {
                    itemView.markAsOwned()
                    break
                }
            }
        }
    }

    updateSubscribedItems(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined) {
        if(ownedMembership == undefined) return
        for(const perk of ownedMembership.perks) {
            if(perk.type == ColonistMembershipPerkType.AllColors) {
                this.markItemsAsSubscribed(StoreItemCategory.Color)
            }
            if(perk.type == ColonistMembershipPerkType.AllMaps) {
                this.markItemsAsSubscribed(StoreItemCategory.Map)
            }
            if(perk.type == ColonistMembershipPerkType.AllExpansions) {
                this.markItemsAsSubscribed(StoreItemCategory.Expansion)
            }
        }
    }

    protected markItemsAsSubscribed(category: StoreItemCategory) {
        for(const itemView of this.items) {
            if(itemView.itemDetail.category != category) continue
            itemView.markAsSubscribed()
        }
    }

    updateOwnedMembership(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined) {
        this.createMembershipItems()
        if(ownedMembership == undefined) return

        let makeUpgrade = false

        const disableMembershipManagement = this.shouldDisableMembershipManagement(paymentMethod)
        const iOwnAnnualMembership = ColonistMembershipProduct.isAnnualMembership(ownedMembership.type)
        for(const membershipView of this.membershipItems) {
            if(disableMembershipManagement) {
                if(membershipView.membershipProduct.type == ownedMembership.type) {
                    const isGift = paymentMethod === PaymentMethod.None
                    if(isGift) {
                        membershipView.changeToCancelButton()
                    } else {
                        membershipView.changeToOwnedButton()
                    }
                    continue
                }
                membershipView.removeButton()
                continue
            }

            if(!iOwnAnnualMembership && ColonistMembershipProduct.isAnnualMembership(membershipView.membershipProduct.type)) {
                membershipView.changeToGoAnnualButton()
                continue
            }
            if(makeUpgrade) {
                membershipView.changeToUpgradeButton()
                continue
            }
            if(membershipView.membershipProduct.type == ownedMembership.type) {
                membershipView.changeToManageButton()
                makeUpgrade = true
                continue
            }
            membershipView.changeToDowngradeButton()
        }
    }

    updatePriceForFounderPack(ownedItems: BaseStoreItem[]) {
        const hasFounderPack = UIWStoreBodyController.hasFounderPack(ownedItems)
        if(!hasFounderPack) return
        for(const itemView of this.items) {
            if(itemView.isMarkedOwned) continue
            if(itemView.itemDetail.category != StoreItemCategory.Expansion && itemView.itemDetail.category != StoreItemCategory.Map) continue
            itemView.makePrice0()
            itemView.updateAction(() => {
                areYouSureToBuyFounderDiscount(itemView.itemDetail, () => {
                    void UIStoreAjaxEndPoints.purchaseItem(itemView.itemDetail)
                })
            })
        }
    }

    updateGiftedMemberships(memberships: GiftedMembershipItem[]) {
        const grid = document.getElementById('store_page_gifted_memberships_div') as HTMLDivElement
        if(grid == undefined) return

        grid.replaceChildren()
        document.getElementById('gifted_memberships')?.classList.toggle('hidden', memberships.length == 0)

        for(const membership of memberships) {
            new UIGiftedMembershipProductView(grid, this.storeState, membership, async(id) => {
                await UIStoreAjaxEndPoints.activateGiftedMembership(id)
            })
        }
    }

    private static hasFounderPack(ownedItems: BaseStoreItem[]): boolean {
        for(const item of ownedItems) {
            if(item.category != StoreItemCategory.PresalePack) continue
            if(item.type != StorePresalePackType.FounderPack) continue
            return true
        }
        return false
    }
}
